<template>
  <div id="app-container" class="d-flex flex-column">
      <!-- <main> -->
      <v-main class="main main-tv">
        <div class="top-bar">
        </div>
        <div class="d-flex align-items-center col-12 large-top">
          <div class="col-5 d-flex justify-content-start responsive-image">
            <img
              :src="require('@/assets/thonburi-logo.png')"
              alt="Phatara-Thonburi Hospital Logo"
            />
          </div>
          <div class="col-7 text-department text-right align-items-center pr-4">
            <div class="padding-title">Medical Record (แผนกเวชระเบียน)</div>
          </div>
        </div>
          <div class="main-content">
              <v-card color="#52B1AA" class="col-11 mx-auto px-0 main-card align-content-center">
                  <div class="row d-flex mx-4">
                      <div v-for="(group, groupIndex) in groupedData" :key="groupIndex" class="col-4 px-0 d-flex justify-content-center">
                          <div class="col-12 text-white pt-0 padding-large" color="#000000" style="width: 95%;">
                              <div class="d-flex">
                                  <v-card-title class="col-6 justify-start subtext-title" style="color: #004848">
                                      หมายเลข
                                  </v-card-title>
                                  <v-card-title class="col-6 justify-end subtext-title text-white" style="color: #ebf7f6">
                                      ช่องบริการ
                                  </v-card-title>
                              </div>
                              <v-card class="d-flex text-center col-12 align-center justify-center mb-5 card-border" style="background: linear-gradient(to right, #ebf7f6 70%, #004848 30%);"
                                v-for="(item, index) in group" :key="index">
                                  <div class="col-8 subtext" style="color: #004848;">
                                      {{ item.queue }}
                                  </div>
                                  <div class="col-4 subtext" style="color: #ebf7f6;">
                                      {{ extractNumber(item.serviceNo) }}
                                  </div>
                              </v-card>
                          </div>
                      </div>
                  </div>
              </v-card>
          </div>
      <!-- </main> -->
      </v-main>
      <v-footer padless :style="{ backgroundColor: '#FFFFFF' }" :class="`fixed-bottom d-flex flex-row justify-content-between align-items-center px-6 ${isPortrait ? '' : 'mt-3'}`">
          <!-- <div class="col py-0">
              <v-icon class="mr-3">
              {{ wifiIcon }}
              </v-icon>
              <v-btn icon color="#000000" @click="changeStatusSound('off')" v-if="statusSound === true">
              <v-icon>mdi-volume-high</v-icon>
              </v-btn>
              <v-btn icon color="#000000" @click="changeStatusSound('on')" v-else>
              <v-icon>mdi-volume-off</v-icon>
              </v-btn>
          </div> -->
          <div class="col d-flex justify-content-start pl-2"><span class="text-footer">POWER BY <span class="ma-2"><img src="@/assets/icon-betask.png" class="size-icon"></span> BETASK CONSULTING</span></div>
          <div class="col py-0 d-flex justify-content-end pr-2"><span class="text-datetime">{{ formattedDate }}</span><span class="ml-12 text-datetime">{{ formattedTime }}</span></div>
      </v-footer>
      <v-row v-show="hideSound === true">
      <audio id="playerTV" controls="controls" ref="playerTV">
        Your browser does not support the audio format.
      </audio>
      <v-col>
        <audio id="playerPrefix" controls="controls">>
          <source
            src="https://firebasestorage.googleapis.com/v0/b/betask-linked/o/ohrich2%2FQNumber.wav?alt=media&token=451f683b-28da-44d0-8673-f5d25a84a9e1">
          Your browser does not support the audio format.
        </audio>
        <audio id="playerQueue" controls="controls">>
          <source :src="audio">
          Your browser does not support the audio format.
        </audio>
        <audio id="playerCounter" controls="controls">>
          <source :src="tableTarget">
          Your browser does not support the audio format.
        </audio>
      </v-col>
      <v-col>
        {{ history }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import VuetifyMoney from '../VuetifyMoney.vue'
import moment from 'moment-timezone'
import { CardWaitingOhrich, BookingUseEventCat, CardSubService } from '../TV'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney,
    CardWaitingOhrich,
    BookingUseEventCat,
    CardSubService
  },
  computed: {
    videoElement () {
      return this.$refs.video
    },
    formattedTime () {
      return moment(this.currentTime, 'DD MMM YYYY HH:mm A').format('HH:mm A').toLowerCase()
    },
    formattedDate () {
      return moment(this.currentTime, 'DD MMM YYYY HH:mm A').format('DD MMM YYYY')
    },
    wifiIcon () {
      switch (this.wifiStatus) {
        case 'connected':
          return 'mdi-wifi'
        case 'disconnected':
          return 'mdi-wifi-off'
        default:
          return 'mdi-wifi-strength-alert-outline'
      }
    },
    sortedDataQueueList () {
    // แยกข้อมูลที่มีค่าและค่าว่าง
      const queueData = this.dataQueueList.filter(item => item.queue !== '' && item.serviceNo !== '')
      const emptyData = this.dataQueueList.filter(item => item.queue === '' || item.serviceNo === '')
      const sortedNonEmptyData = queueData.slice().sort((a, b) => a.index - b.index).reverse()

      // รวมข้อมูลที่มีค่าที่จัดเรียงแล้วและข้อมูลที่ว่าง
      return sortedNonEmptyData.concat(emptyData)
    },
    groupedData () {
      const chunkSize = 2
      const groups = []
      const sortedData = this.sortedDataQueueList

      for (let i = 0; i < sortedData.length; i += chunkSize) {
        groups.push(sortedData.slice(i, i + chunkSize))
      }
      return groups
    }
  },
  created () {
    this.checkWiFiStatus()
    window.addEventListener('online', () => { this.wifiStatus = 'connected' })
    window.addEventListener('offline', () => { this.wifiStatus = 'disconnected' })
    this.getFirestore()
    moment.locale('en')
  },
  data () {
    return {
      tableTarget: 0,
      dataQueueList: [],
      orientation: '',
      statusSound: true,
      dateStartShow: '',
      video: '',
      DarkModeBackground: '#FFFFFF',
      validSearch: true,
      itemBooking: [],
      itemBookingUse: [],
      BookingDataList: [],
      time: '',
      timeavailable: [],
      branchItem: [],
      masBranchID: '',
      flowSelect: '',
      dateStart: '',
      shop: [],
      dialog: false,
      search: '',
      shopColor: '',
      shopImage: '',
      bgColor: '',
      bgColor2: '',
      bgColor3: '',
      text: '',
      videoLinkMonition: '',
      statusSoundCheck: null,
      hideSound: false,
      audio: null,
      timeCount: 0,
      repeatRound: 2,
      speakerId: 27,
      history: [],
      objInterval: null,
      text2: '',
      tableId: 0,
      currentDate: moment().format('DD MMM YYYY'),
      currentTime: moment().format('DD MMM YYYY HH:mm A'),
      isPortrait: true,
      wifiStatus: 'unknown',
      checkRef: false,
      soundQueneNo: [],
      dataListPlay: [],
      dataService: [],
      dataWaiting: [],
      dataSound: [],
      playingSound: [],
      empList: [4300, 4301, 4302, 4303, 4304, 4305, 4306, 4307, 4308, 4309, 4310, 4311, 4312, 4313, 4314, 4315, 4316, 4317, 4318],
      dataListTest1: [1, 2, 3, 4, 5, 6, 7],
      dataListTest2: [1, 2, 3, 4, 5, 6],
      tableAudioList: [
        '',
        'https://firebasestorage.googleapis.com/v0/b/betask-linked/o/ohrich2%2FPleaseContactCounterOne.wav?alt=media&token=0a90f02b-f23b-430c-874c-e476c7701def',
        'https://firebasestorage.googleapis.com/v0/b/betask-linked/o/ohrich2%2FPleaseContactCounterTwo.wav?alt=media&token=7348068e-b96e-4ce4-a2d8-19b13fb6ce55',
        'https://firebasestorage.googleapis.com/v0/b/betask-linked/o/ohrich2%2FPleaseContactCounterThree.wav?alt=media&token=fb455275-eac7-4375-9e9b-3ee2f20182b5',
        'https://storage.googleapis.com/ohrich-sound/PleaseContactCounterFour.wav',
        'https://storage.googleapis.com/ohrich-sound/PleaseContactCounterFive.wav',
        '',
        ''
      ]
    }
  },

  async mounted () {
    this.checkOrientation()
    this.setupEventListeners()
    this.fetchInitialData()
  },
  destroyed () {
    window.removeEventListener('resize', this.checkOrientation)
  },
  beforeDestroy () {
    this.$root.$off('dataReturn')
    clearInterval(this.interval)
    clearInterval(this.intervalSound)
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  },
  methods: {
    getTempleteQueue () {
      return [
        {
          queue: '',
          serviceNo: ''
        },
        {
          queue: '',
          serviceNo: ''
        },
        {
          queue: '',
          serviceNo: ''
        },
        {
          queue: '',
          serviceNo: ''
        },
        {
          queue: '',
          serviceNo: ''
        },
        {
          queue: '',
          serviceNo: ''
        }
      ]
    },
    checkOrientation () {
      this.isPortrait = window.innerHeight > window.innerWidth
    },
    setupEventListeners () {
      window.addEventListener('resize', this.checkOrientation)
      window.addEventListener('orientationchange', this.checkOrientation)
      document.querySelector('body').requestFullscreen()
    },
    async getDataBranch () {
      this.branchItem = await this.getDataFromAPI('/master_branch/get', 'masBranchID', 'masBranchName', '')
      if (this.branchItem.length > 0) {
        this.masBranchID = this.branchItem[0].value
      }
    },
    async getDataFromAPI (url, fieldId, fieldName, param) {
      let result = []
      await axios
        .get(this.$DNS_IP + `${url}?shopId=${this.$session.getAll().data.shopId}${param}`)
        .then(response => {
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              let d = rs[i]
              let s = {}
              s.text = d[fieldName]
              s.value = d[fieldId]
              s.allData = d
              result.push(s)
            // console.log('this.DataFlowName', this.DataFlowName)
            }
          } else {
            result = []
          }
        })
      return result
    },
    async fetchInitialData () {
    // await Promise.all([this.getShop(), this.getBooking(), this.getFirestore()])
      await this.getShop()
      await this.getDataBranch()
      await this.getBooking()
      this.startDateTimeInterval()
    },
    startDateTimeInterval () {
      this.interval = setInterval(() => {
        this.currentTime = moment().format('DD MMM YYYY HH:mm A')
      }, 1000)
    },
    replaceFunc (text) {
      let itemText = text.split('')
      let textFill = ''
      for (let i = 1; i < itemText.length; i++) {
        let d = itemText[i]
        if (d === '0') {
          textFill = textFill + ' zero'
        } else if (d === '1') {
          textFill = textFill + ' one'
        } else if (d === '2') {
          textFill = textFill + ' two'
        } else if (d === '3') {
          textFill = textFill + ' three'
        } else if (d === '4') {
          textFill = textFill + ' four'
        } else if (d === '5') {
          textFill = textFill + ' five'
        } else if (d === '6') {
          textFill = textFill + ' six'
        } else if (d === '7') {
          textFill = textFill + ' seven'
        } else if (d === '8') {
          textFill = textFill + ' eight'
        } else if (d === '9') {
          textFill = textFill + ' nine'
        }
      }
      if (itemText[0] === 'เ') {
        return itemText[0] + itemText[1] + ' ' + textFill
      } else {
        return itemText[0] + ' ' + textFill
      }
    },
    async getFirestore () {
      try {
        if (this.unsubscribe) {
          this.unsubscribe()
        }
        this.firestore = this.$firebase.firestore()
        this.unsubscribe = this.firestore.collection(`QueueOnline/shopId/${this.$session.getAll().data.shopId}`).doc(this.$session.getAll().data.userName)
          .onSnapshot(async (snapshot) => {
            if (!snapshot.exists) {
              await this.createProcessShopNew()
            } else {
              if (snapshot.data().active === '1') {
                await this.updateProcessShopUpdate()
                await this.getBooking()
              }
            }
          })
      } catch (error) {
        console.log('Error getFirestore', error)
      }
    },
    async createProcessShopNew () { // set active = 1
      try {
        let body = {
          userName: this.$session.getAll().data.userName,
          shopId: this.$session.getAll().data.shopId
        }
        await axios.post('https://asia-southeast1-be-linked-a7cdc.cloudfunctions.net/QueueOnline-CreateProcessNew', body)
      } catch (error) {
        console.log('createProcessShopNew error-> ', error)
      }
    },
    async updateProcessShopUpdate () { // update active = 0
      try {
        let body = {
          userName: this.$session.getAll().data.userName,
          shopId: this.$session.getAll().data.shopId
        }
        await axios.post('https://asia-southeast1-be-linked-a7cdc.cloudfunctions.net/QueueOnline-ProcessUseNew', body)
      } catch (error) {
        console.log('updateProcessShopUpdate error-> ', error)
      }
    },
    async changeStatusSound (text) {
      if (text === 'on') {
        this.statusSound = true
        await this.updatestatusNotifyByShopId()
      } else {
        this.statusSound = false
      }
    },
    async updatestatusNotifyByShopId () {
      const params = {
        statusNotify: 'True',
        shopId: this.$session.getAll().data.shopId
      }
      await axios.post(`${this.$DNS_IP}/callQueues/updateStatusNotify`, params)
    },
    async getMessageNoInterval (storeFrontQueue, dueDateDay) {
      try {
        let branchId = this.masBranchID || 2185
        let url = `${this.$DNS_IP}/callQueues/get?statusNotify=False&shopId=${this.$session.getAll().data.shopId}&masBranchID=${branchId}&storeFrontQueue=${storeFrontQueue}&CREATE_DATE=${dueDateDay}`
        await axios
          .get(
            url
          ).then(async (response) => {
            if (response.data.status !== false) {
              let result = await this.generateSound(response.data[0])
              await this.updateMessage(response.data[0].id, result)
            }
          })
      } catch (e) {
        console.log(e)
      }
    },
    updateMessage (id, result) {
      const params = {
        statusNotify: 'True',
        audioFile: result.audio_url
      }
      axios.post(`${this.$DNS_IP}/callQueues/edit/${id}`, params)
    },
    async isSound (typeStoreFront, numberStoreFront) {
      let isSound = false
      try {
        if (typeStoreFront === 'A' && numberStoreFront <= 450) {
          isSound = true
        } else if (typeStoreFront === 'B' && numberStoreFront <= 400) {
          isSound = true
        } else if (typeStoreFront === 'C' && numberStoreFront <= 350) {
          isSound = true
        } else if (typeStoreFront === 'M' && numberStoreFront <= 300) {
          isSound = true
        } else if (typeStoreFront === 'O' && numberStoreFront <= 200) {
          isSound = true
        }
      } catch (error) {
        console.log('error isSound', error)
      }
      return isSound
    },
    async generateSound (item) {
      try {
        this.tableId = item.servicePoint.replace('โต๊ะ ', '')
        let storeFrontQueue = item.storeFrontQueue
        storeFrontQueue = storeFrontQueue.replace('A', 'เอ')
        storeFrontQueue = storeFrontQueue.replace('B', 'บี')
        storeFrontQueue = storeFrontQueue.replace('C', 'ซี')
        storeFrontQueue = storeFrontQueue.replace('D', 'ดี')
        storeFrontQueue = storeFrontQueue.replace('E', 'อี')
        let result
        // let oldSound = this.soundQueneNo.filter((row) => { return row.queue === item.storeFrontQueue })
        item.audioFile = null
        const typeStoreFront = item.storeFrontQueue.substring(0, 1)
        const numberStoreFront = parseInt(item.storeFrontQueue.substring(1))
        if (this.isSound(typeStoreFront, numberStoreFront)) {
          item.audioFile = `https://storage.googleapis.com/thaiairway-sound/${item.storeFrontQueue}.wav`
        } else {
          console.log('oldSound no have')
          await axios
            .get(
              `${this.$DNS_IP}/callQueues/get?storeFrontQueue=${item.storeFrontQueue}&shopId=` + this.$session.getAll().data.shopId + `&audioFile=notNull`
            ).then(async (response) => {
              console.log('nont oldSound callQueues', response.data)
              if ((Array.isArray(response.data) && response.data.length > 0 && this.statusSound) ||
                  (typeof response.data === 'object' && typeof response.data.status !== 'boolean' && this.statusSound)) {
                item.audioFile = response.data[0].audioFile
              }
            })
        }

        if (item.audioFile === null) {
          var params = {
            text: ' ' + storeFrontQueue,
            text_delay: ' ' + storeFrontQueue,
            speaker: this.speakerId,
            volume: 50,
            speed: 0.75,
            type_media: 'wav'
          }
          await axios
            .post(
              'https://api-voice.botnoi.ai/openapi/v1/generate_audio',
              params,
              { headers: { 'Botnoi-Token': 'VTNjZDc5OTM3ZjM4MDg4NzhkYzlkMTI0ZjNiZWZlMTZkNTYxODk0' } }
            ).then((res) => {
              this.dataListPlay.push(res.data)
              this.playSound(res.data)
              result = res.data
            })
        } else {
          let res = { text: item.storeFrontQueue, audio_url: item.audioFile }
          this.dataListPlay.push(res)
          this.playSound(res)
          result = res
        }
        return result
      } catch (e) {
        console.log(e)
        return null
      }
    },
    playSoundBooking (prefixAudio, audioUrl, servicePoint) {
      let playerTV = this.$refs.playerTV

      let playList = []
      try {
        if (playerTV !== undefined) {
          console.log(prefixAudio)
          if (playerTV.paused) {
            let roundCount = 0
            let maxRounds = 2

            if (prefixAudio !== '') {
              playList = [prefixAudio, audioUrl, servicePoint]
            } else {
              playList = [audioUrl, servicePoint]
            }

            let index = 0
            let playNext = () => {
              if (index < playList.length) {
                playerTV.src = playList[index++]
                playerTV.load()
                playerTV.play()
              } else if (roundCount < maxRounds - 1) {
                index = 0
                roundCount++
                playNext()
              }
            }
            playerTV.onended = playNext
            playNext()
          } else {
            this.intervalSound = setTimeout(() => {
              this.playSoundBooking(prefixAudio, audioUrl, servicePoint)
            }, 2000)
          }
        } else {
          console.log('Error playSound : playerTV in null')
        }
      } catch (error) {
        console.log('Error playSound', error)
        playerTV.pause()
      }
    },
    playOnceAndRemove (playList) {
      let playerTV = document.getElementById('playerTV')
      console.log('playOnceAndRemove', playList)
      let index = 0
      let playNext = () => {
        if (index < playList.length) {
          playerTV.src = playList[index++]
          playerTV.load()
          playerTV.play()
        }
      }
      playNext()
      playerTV.removeEventListener('ended', this.playOnceAndRemove)
    },
    async getShop () {
      await axios
        .get(`${this.$DNS_IP}/sys_shop/get?shopId=${this.$session.getAll().data.shopId}`)
        .then(response => {
          let data = response.data
          if (data.length > 0) {
            this.shopColor = data[0].secondaryColor
            this.videoLinkMonition = data[0].videoLinkMonition
          }
        })
    },
    async getBooking () {
      let arrDataService = []
      let dataQueueList = this.getTempleteQueue()
      try {
        await axios.get(`${this.$DNS_IP}/booking_view/getQueueTV?shopId=${this.$session.getAll().data.shopId}&masBranchID=${this.$session.getAll().data.masBranchID}`)
          .then(async response => {
            if (response.data) {
              const data = response.data
              if (data.status) {
                arrDataService = data.dataService
                if (arrDataService !== null && arrDataService.length > 0) {
                  arrDataService.forEach((service, index) => {
                    if (index < dataQueueList.length) {
                      dataQueueList[index].queue = service.storeFrontQueue
                      dataQueueList[index].serviceNo = service.servicePoint
                    }
                  })
                } else {
                  dataQueueList = this.getTempleteQueue()
                }
              } else {
                arrDataService = []
                dataQueueList = this.getTempleteQueue()
              }
            }
          })
      } catch (error) {
        console.log('Error', error)
      }
      this.dataService = arrDataService
      this.dataQueueList = dataQueueList
      // playSound
      if (this.statusSound) {
        console.log('[arrDataService] --->', arrDataService)
        // prefix = 'ขอเชิญคิว'
        let prefix = 'https://storage.googleapis.com/thaiairway-sound/prefix1.wav'
        const fitterDataService = arrDataService.filter(item => item.IsNotify === 'False')
        if (fitterDataService.length > 0) {
          let arrBooking = fitterDataService.map(obj => `'${obj.bookNo}'`).join(',')
          console.log('fitterDataService --->', arrBooking)
          await this.updateNotifyByShopId(arrBooking)
        }
        let servicePoint
        if (arrDataService.length > 0) {
          for (let i = 0; i < arrDataService.length; i++) {
            const item = arrDataService[i]
            if (item.IsNotify === 'False') {
              let audioUrl = `https://storage.googleapis.com/thaiairway-sound/${item.storeFrontQueue}.wav`
              if (item.servicePoint) {
              // ดึงเฉพาะตัวเลขออกมา
                let suffix = item.servicePoint.match(/\d+/)[0]
                // servicePoint = 'ที่ช่องบริการ 1 ค่ะ'
                // (เสียงมี 25 counter)
                servicePoint = `https://storage.googleapis.com/thaiairway-sound/counter${String(suffix).trim()}.wav`
              } else {
              // ถ้าไม่ได้เซ็ตช่องบริการไว้ servicePoint = null
              // servicePoint = 'เข้ารับบริการค่ะ'
                servicePoint = `https://storage.googleapis.com/thaiairway-sound/suffix1.wav`
              }
              const existQueue = this.playingSound.filter(itemNo => itemNo.storeFrontQueue === item.storeFrontQueue)
              if (existQueue.length === 0) {
                this.playingSound.push({ prefix: prefix, audioUrl: audioUrl, servicePoint: servicePoint })
              }
              console.log('playingSound 2 --->', this.playingSound)
            }
          }
        }
      }
      if (this.playingSound.length > 0) {
        console.log('playingSound length > 0')
        for (let index = this.playingSound.length - 1; index >= 0; index--) {
          console.log(this.playingSound[index].prefix, this.playingSound[index].audioUrl, this.playingSound[index].servicePoint)
          this.playSoundBooking(this.playingSound[index].prefix, this.playingSound[index].audioUrl, this.playingSound[index].servicePoint)
          this.playingSound.pop()
        }
      }
    },
    async updateNotifyByShopId () {
      const params = {
        statusNotify: 'True',
        shopId: this.$session.getAll().data.shopId,
        masBranchID: this.masBranchID
      }
      await axios.post(`${this.$DNS_IP}/callQueues/updateStatusNotifyOhrich`, params)
    },
    updateMessageSound (bookNo, audioUrl) {
      try {
        const params = {
          statusNotify: 'True',
          audioFile: audioUrl
        }
        axios.post(`${this.$DNS_IP}/callQueues/edit/${bookNo}`, params)
      } catch (error) {
        console.log('Error updateMessageSound', error)
      }
    },
    checkWiFiStatus () {
      this.wifiStatus = navigator.onLine ? 'connected' : 'disconnected'
    },
    extractNumber (serviceNo) {
      const match = serviceNo.match(/\d+/)
      return match ? match[0] : '' // ดึงตัวเลข ถ้าไม่มีให้คืนค่าว่าง
    }
  }
}

</script>
<style scoped>
.main-tv {
  margin: unset !important;
}
.main-card {
border-radius: 30px 30px 30px 30px !important;
/* width: 1190px; */
/* height: 700px;*/
}

#app-container {
height: 100vh;
overflow: hidden;
}

.text-department{
color: #52B1AA;
font-weight: bold;
font-size: 50px;
}

.subtext-title{
color: #14142B;
font-size: 30px !important;
font-weight: bold;
}

.top-bar{
background: linear-gradient(to right, #52B1AA, #317173);
height: 20px;
}

.text-datetime,
.text-footer {
  font-size: 26px;
  font-weight: 700;
  color: #52B1AA !important;
}

.responsive-image {
  height: 115px;
}

.subtext {
  font-size: 55px;
  font-weight: bold;
}

.subtext {
  font-size: 55px;
  font-weight: bold;
}

.card-border{
border-radius: 15px 15px 15px 15px;
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  .subtext {
      color: #14142B;
      font-size: 10px !important;
      font-weight: bold;
  }
  .subtext-title {
      color: #14142B;
      font-size: 10px !important;
      font-weight: bold;
  }
  .responsive-image {
      height: 115px;
  }
  .text-datetime,
  .text-footer {
      font-size: 12px;
      font-weight: 700;
      color: #52B1AA;
  }
  .main-content {
      height: 90%;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .subtext {
      color: #14142B;
      font-size: 22px !important;
      font-weight: bold;
  }
  .subtext-title {
      color: #14142B;
      font-size: 16px !important;
      font-weight: bold;
  }
  .responsive-image {
      height: 115px;
  }
  .text-datetime,
  .text-footer {
      font-size: 15px;
      font-weight: 700;
      color: #52B1AA;
  }
  .main-content {
      height: 85%;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .subtext {
      color: #14142B;
      font-size: 35px !important;
      font-weight: bold;
  }
  .subtext-title {
      color: #14142B;
      font-size: 22px !important;
      font-weight: bold;
  }
  .responsive-image {
      height: 115px;
  }
  .text-datetime,
  .text-footer {
      font-weight: 700;
      color: #52B1AA;
  }
  .main-content {
      height: 85%;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
  }
}

/* X-Large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .subtext {
      color: #14142B;
      font-size: 47px !important;
      font-weight: bold;
  }
  .subtext-title {
      color: #14142B;
      font-size: 28px !important;
      font-weight: bold;
  }
  .responsive-image {
      height: 115px;
  }
  .text-datetime,
  .text-footer {
      font-weight: 700;
      color: #52B1AA;
  }
  .main-content {
      height: 80%;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
  }
}

/* XX-Large devices (larger desktops, 1400px and up) */
@media (min-width: 1400px) {
  .subtext {
      color: #14142B;
      font-size: 11vh !important;
      font-weight: 900;
  }
  .subtext-title {
      color: #14142B;
      font-size: 4vh !important;
      font-weight: bold;
      margin-top: 4vh;
      margin-bottom: 4vh;
  }
  .responsive-image {
      height: 115px;
  }
  .text-datetime,
  .text-footer {
      font-weight: 700;
      color: #52B1AA;
  }
  .main-content {
      height: 90%;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
  }
  .text-department{
    font-size: 5.5vh;
  }
  .responsive-image {
    height: 10vh;
  }
  .card-border{
    height: 30vh;
  }
}

@media (min-width: 1600px) {
  .subtext {
      color: #14142B;
      font-size: 11vh !important;
      font-weight: 900;
  }
  .subtext-title {
      color: #14142B;
      font-size: 4vh !important;
      font-weight: bold;
      margin-top: 4vh;
      margin-bottom: 4vh;
  }
  .responsive-image {
      height: 115px;
  }
  .text-datetime,
  .text-footer {
      font-weight: 700;
      color: #52B1AA;
  }
  .main-content {
      height: 90%;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
  }
  .text-department{
    font-size: 5.5vh;
  }
  .responsive-image {
    height: 10vh;
  }
  .card-border{
    height: 31vh;
  }
  .main-card{
    margin-bottom: 1vh;
    max-height: 79vh;
    max-width: 172vh;
  }
}

@media (min-width: 3800px) {
  .subtext {
      color: #14142B;
      font-size: 11vh !important;
      font-weight: 900;
  }
  .subtext-title {
      color: #14142B;
      font-size: 4vh !important;
      font-weight: bold;
      margin-top: 4vh;
      margin-bottom: 4vh;
  }
  .responsive-image {
      height: 115px;
  }
  .text-datetime,
  .text-footer {
      font-size: 1.5vh;
      font-weight: 700;
      color: #52B1AA;
      padding-left: 1vh;
      padding-right: 1vh;
  }
  .main-content {
      height: 90%;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
  }
  .text-department{
    font-size: 5.5vh;
  }
  .responsive-image {
    height: 10vh;
  }
  .card-border{
    height: 34vh;
    border-radius: 30px 30px 30px 30px !important;
  }
  .main-card{
    margin-bottom: 1vh;
    margin-left: 6vh;
    max-height: 82vh;
    max-width: 172vh;
    border-radius: 30px 30px 30px 30px !important;
  }
  .large-top{
    margin: 1vh
  }
  .size-icon{
    width: 2.2vh;
    height: 1.5vh;
  }
  .padding-title{
    padding-right: 2vh;
  }
  .padding-large{
    padding-left: 1.5vh;
    padding-right: 1.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Master/BookingListQueueMonitoringVideoPharaThonburi.vue